/**
 * Browser env: Vite exposes VITE_*; keep REACT_APP_* fallback for Node/scripts.
 */
export function getEnv(key, fallback = '') {
  const viteKey = `VITE_${key}`;
  const craKey = `REACT_APP_${key}`;
  if (typeof import.meta !== 'undefined' && import.meta.env?.[viteKey] !== undefined) {
    return import.meta.env[viteKey] || fallback;
  }
  if (typeof process !== 'undefined' && process.env?.[craKey] !== undefined) {
    return process.env[craKey] || fallback;
  }
  return fallback;
}
